import { render, staticRenderFns } from "./QuotationsB2b.vue?vue&type=template&id=5e7be3e3&scoped=true&"
import script from "./QuotationsB2b.vue?vue&type=script&lang=js&"
export * from "./QuotationsB2b.vue?vue&type=script&lang=js&"
import style0 from "./QuotationsB2b.vue?vue&type=style&index=0&id=5e7be3e3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e7be3e3",
  null
  
)

export default component.exports